import { useQuery } from '@tanstack/react-query';
import { getAllRegionales } from '../../../api/carteleriaApi';

function useGetAllRegionales() {
  const { data: regionals, error, isLoading } = useQuery(['regionals'], getAllRegionales);
  return { regionals, error, isLoading };
}

export default useGetAllRegionales;
